module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": _vm.facebookUrl,
      "target": "_blank",
      "aria-label": "Share Page to Facebook"
    }
  }, [_vm._m(0)]), _c('a', {
    attrs: {
      "href": _vm.twitterUrl,
      "target": "_blank",
      "aria-label": "Share Page to Twitter"
    }
  }, [_vm._m(1)]), _c('a', {
    attrs: {
      "href": _vm.emailUrl,
      "aria-label": "Share Page via Email"
    }
  }, [_vm._m(2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": "/static/icons/facebook.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": "/static/icons/twitter.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', [_c('img', {
    attrs: {
      "src": "/static/icons/email.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbcf7e8a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/social.vue
// module id = 248
// module chunks = 1